
import Component, { mixins } from 'vue-class-component';
import WidgetMixins from '../../../mixins/WidgetMixins';
import DialogMixins from '../../../mixins/DialogMixins';
import { Getter, namespace } from 'vuex-class';
import { ISenderID, IUser } from '@/types/types';
import { loadWidget } from '@/utils/helpers';
import { Watch } from 'vue-property-decorator';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const smsModule = namespace('sms');
const authModule = namespace('auth');
const userModule = namespace('users');
@Component({
  name: 'Index',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    ProgressBar: loadWidget('widgets/CircularProgressLoader'),
    DeleteDialog: loadWidget('widgets/DeleteDialog'),
    AddSMSSenderID: loadWidget(`widgets/AddSenderID`),
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
  filters: {},
})
export default class Index extends mixins(WidgetMixins, DialogMixins) {
  @Getter('getCreditBalance') creditBalance!: number;
  @authModule.Getter('getUserDetails') user!: IUser;
  @userModule.Getter('getSearchResults') rawSubAccountList!: Array<IUser>;
  // @smsModule.Getter('getSenderIDList') approvedSenderIDlist!: Array<
  //   ISenderID & { id: number; slug: string; uuid: string; isApproved: boolean }
  // >;
  // @smsModule.Getter('getSubAccountsSenderIDList')
  // subAccountsSenderIDList!: Array<
  //   ISenderID & { id: number; slug: string; uuid: string }
  // >;

  tabs = 0;
  senderIdFilter = null;
  senderIdBySubAccountID = null;

  get approvedSenderIDlist(): Array<
    ISenderID & { id: number; slug: string; uuid: string; isApproved: boolean }
  > {
    if (this.senderIdFilter === null || this.senderIdFilter === undefined) {
      return this.$store.getters['sms/getSenderIDList'];
    }
    return this.$store.getters['sms/getSenderIDList'].filter(
      (senderId: ISenderID & { isApproved: boolean }) =>
        senderId.isApproved === this.senderIdFilter
    );
  }
  get subAccountsSenderIDList(): Array<
    ISenderID & { id: number; slug: string; uuid: string }
  > {
    if (
      this.senderIdBySubAccountID === null ||
      this.senderIdBySubAccountID === undefined
    ) {
      return this.$store.getters['sms/getSubAccountsSenderIDList'];
    }
    return this.$store.getters['sms/getSubAccountsSenderIDList'].filter(
      (account: ISenderID & { userId: number }) =>
        account.userId === this.senderIdBySubAccountID
    );
  }

  get titles(): Array<string> {
    return !this.user.isSubAccount && this.user.businessId?.isBusinessReseller
      ? ['My Account', 'Sub Accounts']
      : ['My Account'];
  }

  @Watch('rawSubAccountList')
  onRawSubAccountListChanged(value: Array<IUser>): void {
    if (value) {
      this.$store.dispatch(
        'sms/listAllSenderIdsBySubAccountId',
        value.map((u) => u.id)
      );
    }
  }
  deleteSenderID(): void {
    const payload = this.$store.getters['sms/getSenderIDDetails'];
    this.$store.dispatch('sms/deleteSenderID', payload);
  }

  created(): void {
    //this.$store.dispatch('sms/pendingSenderID');
    this.$store.dispatch('sms/listSenderID');
    this.$store.dispatch('users/rawList');
  }
}
